"use strict";
// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./htmlmanager"));
var libembed_amd_1 = require("./libembed-amd");
exports.requireLoader = libembed_amd_1.requireLoader;
exports.version = require('../package.json').version;
function generateEmbedScript(widgetState, imageDataUrl) {
    return [
        '<img src=' + imageDataUrl + ' class="jupyter-widget">',
        '<script type="application/vnd.jupyter.widgets-state+json">' + JSON.stringify(widgetState) + '</script>'
    ].join('\n');
}
exports.generateEmbedScript = generateEmbedScript;
